// components/common/KpiCard.tsx
import clsx from 'clsx';
import React from 'react';

type TrendDirection = 'up' | 'down' | 'neutral';

interface KpiCardProps {
    label: string;
    value: string;
    helperText?: string; // e.g. "Predicted" / "Month over month"
    trendValue?: string; // e.g. "+7.37%"
    trendDirection?: TrendDirection;
    className?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({
    label,
    value,
    helperText,
    trendValue,
    trendDirection = 'neutral',
    className,
}) => {
    const trendColor =
        trendDirection === 'up'
            ? 'text-emerald-600'
            : trendDirection === 'down'
              ? 'text-red-600'
              : 'text-slate-500';

    return (
        <div
            className={clsx(
                'flex flex-col justify-between rounded-xl border border-slate-100',
                'bg-white px-5 py-4 shadow-sm',
                'min-w-[220px]',
                className,
            )}
        >
            <div className="text-xs font-medium tracking-wide text-slate-500 uppercase">
                {label}
            </div>

            <div className="mt-2 flex items-baseline gap-2">
                <span className="text-2xl font-semibold text-slate-900">
                    {value}
                </span>

                {trendValue && (
                    <span className={clsx('text-xs font-medium', trendColor)}>
                        {trendValue}
                    </span>
                )}
            </div>

            {helperText && (
                <div className="mt-1 text-xs text-slate-500">{helperText}</div>
            )}
        </div>
    );
};

export default KpiCard;
